import "../Styles/Frontend/frontend.scss";

import "./Chunk/Frontend/data_tables_async";
import "./Chunk/Frontend/data_table_default";
import "./Chunk/Frontend/create_tab";
